export default "__VITE_ASSET__Daat4Ha6__"